import {FormControlLabel, Switch} from "@material-ui/core";

type OrganizationsSwitchType = {
    isStacked: boolean;
    setIsStacked: (param: boolean)=> void;
}

const OrganizationsSwitch = ({isStacked, setIsStacked }: OrganizationsSwitchType) => {
    return (
        <div className={'showOrgButton'}>
            <FormControlLabel labelPlacement="start"
                              label="Pokaż gminy"
                              control={<Switch checked={isStacked}
                                               color={'primary'}
                                               onChange={() => setIsStacked(!isStacked)}
                                               name="Pokaż gminy"/>}/>
        </div>);
}

export {OrganizationsSwitch}